import styled from 'styled-components/macro'

export const CustomGroups = styled.div`
  display: grid;
  margin: 1rem 0;
  gap: 0.5rem;
  width: 100%;
`

export const CustomGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const CustomGroupFieldsWrapper = styled.div`
  display: grid;
  grid-auto-rows: auto; 
`

export const CustomGroupTitleWrapper = styled.div`
`

export const CustomGroupTitle = styled.h2`
  font-weight: 700;
  line-height: 3.8rem;
  letter-spacing: -0.1rem;
  color: ${({ theme }) => theme.colors.mono.black};
`